import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import { tap } from "rxjs/operators";
import { Address } from '../../models/address.model';
import { DomainDefinitionService } from "../../../builder/services/domain-definition.service";

@Component({
    selector: 'address-block',
    templateUrl: './address-block.component.html',
    styleUrls: ['./address-block.component.scss'],
    standalone: false
})
export class AddressBlockComponent implements OnInit, OnDestroy {

	@Output() addressUpdated: EventEmitter<Address> = new EventEmitter<Address>();

	@Input() address: Address;

	@Input() canEdit: boolean = false;

	@Input() form: FormGroup = new FormGroup({});

	private _editingField: string = "";

	get editingField(): string {
		return this._editingField;
	}

	get streetAddress(): string {
		if (this.canEdit) {
			let ctrl = this.form.get('streetAddress');
			if (ctrl != null) {
				return ctrl.value;
			}			
		}
		return this.address.street;
	}

	private _subscription: Subscription;

	private _states: any[] = [];

	get states(): any[] {
		return this._states;
	}


	constructor(private _domain: DomainDefinitionService) { }

	ngOnInit() {
		const stateObs$: Observable<any> = this._domain.getValues("STATE").pipe(
			tap((data: any) => {
				data.forEach(d => {
					const obj = { Code: d.Code, Definition: d.Definition };
					this.states.push(obj);
				})
			})
		);
		this._subscription = stateObs$.subscribe(
			() => { },
			(err) => {
				console.error(err);
			}
		);
	}

	ngOnDestroy() {
		if (this._subscription != null) {
			this._subscription.unsubscribe();
		}
	}

	editField(fieldName: string): void {
		if (this._editingField != "") {
			this.update(this._editingField);
		}
		this._editingField = fieldName;
		let ctrl = this.form.get(fieldName);
		if (ctrl != null) {
			ctrl.enable();
		}
		console.log('looking for element with name', fieldName);

		setTimeout(() => {
			let el = document.getElementById(fieldName);
			console.log('el', el);
			if (el != null) {
				el.focus();
			}
		}, 500);
	}

	update(fieldName: string): void {
		let ctrl = this.form.get(fieldName);
		switch (fieldName) {
			case "streetAddress":
				{					
					if (ctrl != null) {
						this.address.street = ctrl.value;
						ctrl.disable();
					}									
					break;
				}
			case "suite":
				{
					if (ctrl != null) {
						this.address.suite = ctrl.value;
						ctrl.disable();
					}
					break;
				}
			case "poBox":
				{
					if (ctrl != null) {
						this.address.poBox = ctrl.value;
						ctrl.disable();
					}
					break;
				}
			case "city":
				{
					if (ctrl != null) {
						this.address.city = ctrl.value;
						ctrl.disable();
					}
					break;
				}
			case "state":
				{
					if (ctrl != null) {
						this.address.stateCode = ctrl.value;
						ctrl.disable();
					}
					break;
				}
			case "zipCode":
				{
					if (ctrl != null) {
						this.address.zipCode = ctrl.value;
						ctrl.disable();
					}
					break;
				}
		}
		this._editingField = "";
		this.addressUpdated.emit(this.address);
	}
}
